<div class="modal-header-block title">
  <h2>Upload Transaction Activity Document</h2>
  <button class="close-button" (click)="activeModal.close()">
    <rkt-icon name="times"></rkt-icon>
  </button>
</div>

<div class="details-page-edit-form">
  <div class="file-drop">
    <app-file-upload title="Drag & drop files here" [fileTypes]="['text/csv']" (selectedFile)="onFileUploaded($event)"></app-file-upload>
  </div>

  <div class="buttons">
    <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
    <button
      rktButton
      type="submit"
      (click)="onSubmit()"
      [disabled]="isLoading || !(formModel.isFileUploaded || documentUploadData)"
      title="Upload"
    >
      Upload
    </button>
  </div>
</div>
